module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"goalNone":"None","goalReduce":"Reduce","goalIncrease":"Increase","goalApproximate":"Approximate"},"de":{"goalNone":"Kein","goalReduce":"Reduzieren","goalIncrease":"Erhöhen","goalApproximate":"Annähern"}}')
  delete Component.options._Ctor
}
